export default "__VITE_ASSET__VTgM31He__"